import { api, apiService } from "./api";

export interface GetNdrParams {
  userId: number;
  page?: number;
  pageSize?: number;
  minimumInfo?: boolean;
  status?:number;
  search?: string;
  courier_id?: string;
  fromDate?: string;
  toDate?: string;
}

export interface UpdateNdrPayload {
  tracking_number: string;
  courier_id?: number;
  courier_remark?: string;
  shipper_remark_id?: number;
  additional_comment?: string;
  consignee_remark_id?: number;
  action: string;
  delivery_attempt_count?: number;
  is_fake?: number;
  updated_consignee_address?: string;
  updated_consignee_name?: string;
  updated_consignee_contact_no?: string;
  updated_delivery_date?: number;
}

export const ndrService = {
  getNdrByUserId: async ({
    userId,
    page = 1,
    pageSize = 10,
    minimumInfo = false,
    status,
    search,
    courier_id,
    fromDate,
    toDate
  }: GetNdrParams) => {
    const response = await api.get(
      `/ndr/users/${userId}`,
      {
        params: {
          page,
          pageSize,
          minimumInfo,
          status,
          search,
          courier_id,
          fromDate,
          toDate
        },
      }
    );
    return response.data;
  },

  updateNdr: async (userId: number, payload: UpdateNdrPayload) => {
    const response = await api.put(
      `/ndr/users/${userId}`,
      payload
    );
    return response.data;
  },

  getShipperRemarks: async () => {
    const response = await api.get(
      `/ndr/shipperRemarks`
    );
    return response.data;
  },

  getConsigneeRemarks: async () => {
    const response = await api.get(
      `/ndr/consigneeRemarks`
    );
    return response.data;
  },

  getNdrHistory: async (trackingNo: string) => {
    const response = await api.get(
      `/ndr/${trackingNo}/history`
    );
    return response.data;
  },

  downloadNdr: async (courierId: string, fromDate?: string) => {
    const params: any = {};
    if (fromDate) params.fromDate = fromDate;
    const response = await api.get(`/open/download/${courierId}/ndr`, { params });
    return response.data;
  },
};
